import * as React from 'react';

export type ItemCounterProps = {
    value: number;
    className?: string;
};

const ItemCounter: React.FunctionComponent<ItemCounterProps> = ({ className = '', value }) => (
    <div className={`label label-default ${className}`} style={{ cursor: 'default' }}>
        {value}
    </div>
);

ItemCounter.displayName = 'ItemCounter';

export default ItemCounter;
